var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    loadingMain: false,
};
var layoutSlice = createSlice({
    name: 'layout',
    initialState: initialState,
    reducers: {
        toggleLoadingMain: function (state) {
            return __assign(__assign({}, state), { loadingMain: !state.loadingMain });
        },
    },
});
export var toggleLoadingMain = layoutSlice.actions.toggleLoadingMain;
export default layoutSlice.reducer;
